import { DocumentNode } from 'graphql';
import { BillsQuery, OrdersQuery, QueryBillsArgs, QueryOrdersArgs } from '../../../../generated/graphql';

type Bills = BillsQuery['bills'];
type Bill = Bills[0];

type Orders = OrdersQuery['orders'];
type Order = Orders[0];

export type QueryArgs = QueryBillsArgs | QueryOrdersArgs;

interface OrdersQueryResult {
    orders: Order[];
}

export type QueryResult = BillsQuery | OrdersQuery;

export interface ItemsListViewProps {
    hasMore: boolean;
    loadMore: () => Promise<void>;
    items: Array<Bill | Order>;
}


export function isOrder(item: Bill | Order): item is Order {
    return (item as Order).orderState !== undefined;
}

export function isOrderQuery(queryResult: QueryResult): queryResult is OrdersQueryResult {
    return (queryResult as OrdersQueryResult).orders !== undefined;
}

export interface QueryComponentProps {
    query: DocumentNode;
    queryArgs: QueryArgs;
}